import { createClient } from "@supabase/supabase-js";

let REACT_APP_SUPABASE_URL = `https://pkiufxpxcjmkneqtxbcn.supabase.co`;
let REACT_APP_SUPABASE_PUBLISHABLE_KEY = `sb_publishable_seHfBA5leBLM5wF0dLaUIA_mBBGTj6T`;

const supabaseUrl = REACT_APP_SUPABASE_URL;
const supabaseKey = REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);